// extracted by mini-css-extract-plugin
export default {"p":"Text_p__vSjMG","button":"Text_button__fs+O4"};